import { createFileRoute } from '@tanstack/react-router'
import { NotificationsPage } from '@/features/notifications'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/reseller/notifications')({
  component: NotificationsPage,
  beforeLoad: requireRole(['reseller']),
})
